/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Free_Trial_ButtonInputs */

const en_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free trial`)
};

const id_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai uji coba gratis`)
};

const ms_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulakan percubaan percuma`)
};

const ca_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia una prova gratuïta`)
};

const cs_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahájit zkušební verzi zdarma`)
};

const da_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begynd gratis prøveperiode`)
};

const de_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos testen`)
};

const et_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alusta tasuta prooviperioodi`)
};

const es_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia la prueba gratuita`)
};

const fr_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer mon essai gratuit`)
};

const hr_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počnite besplatno probno razdoblje`)
};

const it_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia la prova gratuita`)
};

const lv_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sākt bezmaksas izmēģinājuma periodu`)
};

const lt_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pradėti nemokamą bandomąją versiją`)
};

const hu_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes próba indítása`)
};

const nl_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis proefperiode starten`)
};

const nb_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start prøveperiode`)
};

const pl_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij bezpłatny okres próbny`)
};

const pt_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar teste gratuito`)
};

const ro_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Începeți un trial gratuit`)
};

const sk_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začať skúšobnú verziu`)
};

const sl_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začni brezplačni preizkus`)
};

const fi_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita ilmainen kokeilujakso`)
};

const sv_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starta gratis provperiod`)
};

const vi_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu dùng thử miễn phí`)
};

const tr_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz denemeyi başlat`)
};

const el_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έναρξη δωρεάν δοκιμής`)
};

const bg_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Започни безплатния пробен период`)
};

const ru_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатный пробный период`)
};

const sr_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покрени бесплатну пробу`)
};

const uk_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почніть безкоштовну пробну версію`)
};

const ka_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`უფასო საცდელი პერიოდის დაწყება`)
};

const hi_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त ट्रायल शुरू करें`)
};

const th_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มต้นทดลองใช้ฟรี`)
};

const ko_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 평가판 시작`)
};

const zh_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始免费试用`)
};

const zh_tw_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即免費試用`)
};

const ja_start_free_trial_button = /** @type {(inputs: Start_Free_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料トライアルを開始`)
};

/**
* | output |
* | --- |
* | "Start free trial" |
*
* @param {Start_Free_Trial_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const start_free_trial_button = /** @type {((inputs?: Start_Free_Trial_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Free_Trial_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_start_free_trial_button(inputs)
	if (locale === "ms") return ms_start_free_trial_button(inputs)
	if (locale === "ca") return ca_start_free_trial_button(inputs)
	if (locale === "cs") return cs_start_free_trial_button(inputs)
	if (locale === "da") return da_start_free_trial_button(inputs)
	if (locale === "de") return de_start_free_trial_button(inputs)
	if (locale === "et") return et_start_free_trial_button(inputs)
	if (locale === "es") return es_start_free_trial_button(inputs)
	if (locale === "fr") return fr_start_free_trial_button(inputs)
	if (locale === "hr") return hr_start_free_trial_button(inputs)
	if (locale === "it") return it_start_free_trial_button(inputs)
	if (locale === "lv") return lv_start_free_trial_button(inputs)
	if (locale === "lt") return lt_start_free_trial_button(inputs)
	if (locale === "hu") return hu_start_free_trial_button(inputs)
	if (locale === "nl") return nl_start_free_trial_button(inputs)
	if (locale === "nb") return nb_start_free_trial_button(inputs)
	if (locale === "pl") return pl_start_free_trial_button(inputs)
	if (locale === "pt") return pt_start_free_trial_button(inputs)
	if (locale === "ro") return ro_start_free_trial_button(inputs)
	if (locale === "sk") return sk_start_free_trial_button(inputs)
	if (locale === "sl") return sl_start_free_trial_button(inputs)
	if (locale === "fi") return fi_start_free_trial_button(inputs)
	if (locale === "sv") return sv_start_free_trial_button(inputs)
	if (locale === "vi") return vi_start_free_trial_button(inputs)
	if (locale === "tr") return tr_start_free_trial_button(inputs)
	if (locale === "el") return el_start_free_trial_button(inputs)
	if (locale === "bg") return bg_start_free_trial_button(inputs)
	if (locale === "ru") return ru_start_free_trial_button(inputs)
	if (locale === "sr") return sr_start_free_trial_button(inputs)
	if (locale === "uk") return uk_start_free_trial_button(inputs)
	if (locale === "ka") return ka_start_free_trial_button(inputs)
	if (locale === "hi") return hi_start_free_trial_button(inputs)
	if (locale === "th") return th_start_free_trial_button(inputs)
	if (locale === "ko") return ko_start_free_trial_button(inputs)
	if (locale === "zh") return zh_start_free_trial_button(inputs)
	if (locale === "zh-tw") return zh_tw_start_free_trial_button(inputs)
	if (locale === "ja") return ja_start_free_trial_button(inputs)
	return en_start_free_trial_button(inputs)
});